// src/utils/validators.js

const API_BASE =
    "https://api.shipez.ai/api/v1/CompanySetup";

const createValidator = ({
    endpoint,
    queryKey,
    fieldName,
}) => {
 
    return async (value = "") => {
 
        try {
 
            const trimmedValue = String(value).trim();
 
            // EMPTY
            if (!trimmedValue) {
 
                return {
                    valid: false,
                    message: `${fieldName} is required`,
                };
            }
 
            // TOKEN
            const token =
                localStorage.getItem("authToken");
 
            // API CALL
            const response = await fetch(
                `${API_BASE}/${endpoint}?${queryKey}=${encodeURIComponent(
                    trimmedValue
                )}`,
                {
                    method: "GET",
 
                    headers: {
                        "Content-Type":
                            "application/json",
 
                        ...(token && {
                            Authorization:
                                `Bearer ${token}`,
                        }),
                    },
                }
            );
 
            // PARSE JSON
            const data = await response.json();
 
            const available = data?.data === "Available";
 
            return {
                valid: available,
 
                message: available
                    ? `${fieldName} is available`
                    : `${fieldName} already taken`,
            };
 
        } catch (error) {
 
            console.error(
                `${fieldName} validation error:`,
                error
            );
 
            return {
                valid: false,
 
                message:
                    error?.message ||
                    `Unable to validate ${fieldName}`,
            };
        }
    };
};
 
 
// Export reusable validators
export const validateEmail = createValidator({
    endpoint: "ValidateEmailId",
    queryKey: "EmailId",
    fieldName: "Email",
});

export const validateUsername = createValidator({
    endpoint: "ValidateUsername",
    queryKey: "Username",
    fieldName: "Username",
});

export const validateCompanyName = createValidator({
    endpoint: "ValidateCompanyName",
    queryKey: "CompanyName",
    fieldName: "Company Name",
});